import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Section, SectionHeader, reveal } from "../../components";

const pillars = [
  {
    title: "Backend Engineering",
    content:
      "We deliver robust backend solutions designed with microservices and agile architecture. Our approach ensures scalable, flexible, and high-performing systems engineered for excellence. We focus on reliable, secure, and maintainable infrastructure for seamless integration.",
    tags: ["Microservices", "Scalability", "Agile"],
  },
  {
    title: "Intuitive Design",
    content:
      "Our team crafts stunning, user-friendly interfaces that offer an intuitive experience across all devices. We emphasize clean, responsive designs that engage users and drive satisfaction, ensuring the success of every product through ease of use.",
    tags: ["Responsive", "UX/UI", "Clean Design"],
  },
  {
    title: "Digital Presence",
    content:
      "We offer comprehensive social media management for organizations and teams, helping you enhance your online presence, connect with your audience, and build a stronger digital footprint through strategic engagement.",
    tags: ["Social Media", "Branding", "Growth"],
  },
];

const Skills = () => {
  const { t } = useTranslation();

  return (
    <Section id="skills" tone="paper">
      <SectionHeader
        index="06"
        label={t("Capabilities & Expertise")}
        title={
          <>
            {t("How the work")} <em>{t("gets made")}</em>
          </>
        }
        aside={
          <p className="label max-w-[20ch] leading-relaxed">
            {t("Standard")}
            <span className="block mt-2 font-sans text-sm font-normal normal-case tracking-normal text-ink">
              {t("Enterprise Grade Delivery")}
            </span>
          </p>
        }
      />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 mt-14 md:mt-20">
        {pillars.map((pillar, idx) => (
          <motion.div
            key={pillar.title}
            {...reveal(idx)}
            className="border-t border-[color:var(--rule)] pt-6"
          >
            <span className="label tabular text-gold-ink">
              {String(idx + 1).padStart(2, "0")}
            </span>
            <h3 className="display-2 mt-4">{t(pillar.title)}</h3>
            <p className="prose-body mt-4 text-[0.9375rem]">{t(pillar.content)}</p>
            <p className="mt-6 text-xs text-ink-faint">
              {pillar.tags.map((tag) => t(tag)).join("  ·  ")}
            </p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default Skills;
